import { render, staticRenderFns } from "./pointTask.vue?vue&type=template&id=be8223c6&scoped=true"
import script from "./pointTask.vue?vue&type=script&lang=js"
export * from "./pointTask.vue?vue&type=script&lang=js"
import style0 from "./pointTask.vue?vue&type=style&index=0&id=be8223c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8223c6",
  null
  
)

export default component.exports